@use '@/scss/underscore' as _;

.type,
.description {
  @include _.text-ellipsis;
}
